module.exports = __webpack_public_path__ + "img/cardbg-4.b7440276.jpeg";